/**
 * #typeRegistry.ts
 *
 * Code generated by ts-proto. DO NOT EDIT.
 * @packageDocumentation
 */
/* eslint-disable */
export const messageTypeRegistry = new Map();
